import { Component, OnInit } from '@angular/core';
import { ShopService } from '../../../configuration/services/shop.service';
import { DistributorService } from '../../../distributors/services/distributor.service';
import { ExpectedExpensesService } from '../../services/expected-expenses.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-view-expected-expenses',
  templateUrl: './view-expected-expenses.component.html',
  styleUrls: ['./view-expected-expenses.component.css'],
  providers: [DistributorService,ShopService,ExpectedExpensesService]
})
export class ViewExpectedExpensesComponent implements OnInit {
    id: number = undefined;
    productId: number = undefined;
    private sub: any;
    expectedExpense: any = {};
    config: any = {'sourceField': ['name']};


  constructor(private route: ActivatedRoute, private router: Router, private shopService:ShopService, private distributorService:DistributorService, private expectedExpensesService:ExpectedExpensesService) { 
    this.sub = this.route.params.subscribe(params => {
        if (params['id'] !== undefined){
            this.id = params['id'];
            this.getExpectedExpense();
        }
    });
  }

  ngOnInit() {
  }

  getExpectedExpense(){
    this.expectedExpensesService.get(this.id).subscribe((expectedExpense) => {
        this.expectedExpense = expectedExpense;
        if (this.expectedExpense.valid_from){
          this.expectedExpense.valid_from = moment(this.expectedExpense.valid_from).format("YYYY-MM-DD")
        }
        if (this.expectedExpense.valid_until){
          this.expectedExpense.valid_until = moment(this.expectedExpense.valid_until).format("YYYY-MM-DD")
        }
    });
  }

  saveExpectedExpense(){
    if (!this.expectedExpense.id){
        this.expectedExpensesService.create(this.returnProperties(this.expectedExpense)).subscribe((expectedExpense) =>{
            this.expectedExpense = expectedExpense;
            this.router.navigate(["/expenses/expected/list"]); 
        });
    }else{
        this.expectedExpensesService.update(this.returnProperties(this.expectedExpense)).subscribe((expectedExpense) =>{
            this.expectedExpense = expectedExpense;
            this.router.navigate(["/expenses/expected/list"]); 
        });
    }
  }

  returnProperties(expectedExpense){
    var properties = {
        concept: expectedExpense.concept,
        amount: expectedExpense.amount,
        valid_from: expectedExpense.valid_from,
        valid_until: expectedExpense.valid_until == ""?null:expectedExpense.valid_until,
        type: expectedExpense.type
    }
    if (expectedExpense.id){
      properties['id'] = expectedExpense.id;
    }
    return properties;
  }

  
}


// WEBPACK FOOTER //
// ./src/app/expenses/components/view-expected-expenses/view-expected-expenses.component.ts